import { useState, useEffect } from "react";
import {useHistory, Link} from "react-router-dom";
import { useSelector } from "react-redux";
import { getBusinessPartnerModel } from "../../BusinessPartner/Infrastructure/BusinessPartner.reducer";
import { makeStyles } from "@mui/styles";
import { Avatar } from "@mui/material";
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PowerSettingsNewRoundedIcon from '@mui/icons-material/PowerSettingsNewRounded';
import { Logout } from "../../Auth/Infrastructure/Auth.presenter";
import MenuButton from "../../DesignSystem/MenuButton";
import EditRoundedIcon from '@mui/icons-material/EditRounded';

//import GetBusinessPartnerInfo from "../../BusinessPartner/Infrastructure/BusinessPartner.presenter";


const useStyles = makeStyles((theme) => ({
  profileContainer:{
    marginTop: "5vh",
    minHeight: "90vh",
    background: "#ffffff",
    padding: "30px 15px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    gap: 20,
    /* [theme.breakpoints.up("xl")]:{
      display: "none"
    }, */
    width: "50%",
    marginLeft: "25%",
    backgroundColor: "#ffffff",
    borderRadius: "15px",
  },
  infoContainer:{
    paddingLeft: 10,
    width: "90%",
    maxHeight: 170,
    display: "flex",
    justifyContent: "flex-start",
    gap: 20,
    flexDirection: "column",

    alignItems: "center",
  },
  info:{
    
    //border: "1px solid blue",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "start",
    flexDirection: "column",
    gap:2,
  },
  name:{
    fontSize: "1.125rem",
    lineHeight: "22px",
    color: "#000000",
    fontWeight: 500,
  },
  description:{
    fontSize: "0.875rem",
    lineHeight: "17.07px",
    color: "#EA5B13",
    fontWeight: 500,
    maxWidth: 190
  },
  butonscontainer:{
    display: "flex",
    flexDirection: "column",
    marginTop: "15%",
    width: "100%",
  }
}));

export default function UserProfile(){
  const classes = useStyles()
  const history = useHistory();
  const [info, setInfo] = useState({});
  const businessPartner = useSelector(getBusinessPartnerModel);

  useEffect(() => {
    if (businessPartner) {
      setInfo({name: businessPartner.name, lastName: businessPartner.last_name, zone: businessPartner.zone, photo: businessPartner.url_photoProfile})
    }
  }, [businessPartner]);

  const logout = async () => {
    try {
      await Logout();
      history.push("/");
    } catch (error) {
      alert("error signing out: ", error);
    }
  };

  return(
    <div className={classes.profileContainer}>
      <div className={classes.infoContainer}>
        <Avatar sx={{width: "150px", height: "150px", border: "3px solid", borderColor: "#EA5B13"}} src={info.photo} />
        <div className={classes.info}>
        <p className={classes.description} ><EditRoundedIcon sx={{color: "#EA5B13", fontSize:"0.875rem"}}/> Editar</p>
          <h4 className={classes.name}>{`${info.name || ""} ${info.lastName || ""}`}</h4>
       
        </div>
      </div>
      <div className={classes.butonscontainer}>
      <MenuButton icon={<FolderOutlinedIcon sx={{color: "#4F4F4F"}}/>} title="Ver reportes" widthBtn="100%"/>
      <MenuButton onClick={<Link to="/choose"></Link>} icon={<SettingsOutlinedIcon sx={{color: "#4F4F4F"}}/>} title="Configuración" widthBtn="100%"/>
      <MenuButton  icon={<SettingsOutlinedIcon sx={{color: "#EA5B13"}}/>} title="Datos Bancarios" widthBtn="100%" redirect="/elegir" />
      <MenuButton icon={<PowerSettingsNewRoundedIcon sx={{color: "#4F4F4F"}}/>} title="Cerrar sesión" onClick={logout} widthBtn="100%"/>
      </div>
    </div>
  );
}